// extracted by mini-css-extract-plugin
module.exports = {"welcomeContainer":"Welcome_welcomeContainer__1xRT1","first":"Welcome_first__2u75s","second":"Welcome_second__3Pv4u","fade-in":"Welcome_fade-in__32ImK"};